module.exports = __webpack_public_path__ + "static/img/img-main-sam@2x.30729d50.png";